import { MrbBaseListViewStore } from "mrb/core";
import { MrbGridViewStore } from "mrb/components/grid";
import { action, computed } from "mobx";
import { subscriptionPlans } from "common/constants";
import { some } from "lodash";
import DeviceOnboardingViewStore from "./DeviceOnboardingViewStore";

class DeviceListViewStore extends MrbBaseListViewStore {
    @computed get isAddDeviceEnabled() {
        return this.rootStore.userDeviceStore.isDeviceSlotAvailable;
    }

    @computed get isAddDeviceVisible() {
        return this.rootStore.premiumSubscriptionStore.hasPortalAccess;
    }

    @computed get deviceLimit() {
        return this.rootStore.userDeviceStore.deviceLimit;
    }

    @computed get inNakiOneActiveOrScheduled() {
        return some(
            this.rootStore.premiumSubscriptionStore.subscriptions,
            (s) => s.product.slug === subscriptionPlans.nakiOne
        );
    }

    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            layoutActions: {
                create: {
                    onClick: () => this.rootStore.routerStore.goTo("master.application.device.create"),
                    label: "Add New Device",
                },
            },
            queryConfig: {
                embed: "device,device.systemType",
                orderBy: "deviceName",
                orderDirection: "asc",
            },
        });
        this.routeStore = routeStore;
        this.onboardingViewStore = new DeviceOnboardingViewStore(rootStore, { routeStore });

        this.setGridStore(
            new MrbGridViewStore(this.rootStore, this.queryUtility, {
                onCellClick: (item) =>
                    this.rootStore.routerStore.goTo("master.application.device.edit", { id: item.id }),
                actions: {
                    delete: {
                        onClick: (item) => this.deleteUserDevice(item),
                    },
                },
            })
        );

        this.joyrideSteps = [
            {
                target: ".c-device__card--sml",
                content: "Here you can set prohibited time for this device!",
            },
        ];

        this.goToAddNewDevice = this.goToAddNewDevice.bind(this);
    }

    async onInit() {
        await this.rootStore.userDeviceStore.loadUserDevices();
        // Load content-mode options regardless of device count, so the onboarding
        // dropdown is populated even if the user later deletes their last device.
        this.onboardingViewStore.load();
        return super.onInit();
    }

    find(params) {
        return this.routeStore.findUserDevices(params);
    }

    goToAddNewDevice() {
        this.rootStore.routerStore.goTo("master.application.device.create");
    }

    @action.bound
    showDeviceLimitReachedPopup() {
        this.rootStore.confirmDialogStore.showConfirm({
            message: "Device limit reached.",
            description: "Upgrade to Naki Family subscription to unlock additional devices.",
            onConfirm: () => this.rootStore.routerStore.goTo("master.application.premium.subscriptions"),
            yesLabel: "Upgrade",
            noLabel: "Cancel",
        });
    }

    @action.bound
    async deleteUserDevice(resource) {
        this.rootStore.confirmDialogStore.showConfirm({
            message: "Do you want to delete device?",
            onConfirm: async () => {
                try {
                    this.rootStore.mainLoaderStore.suspend();
                    await this.routeStore.deleteUserDevice(resource);
                    this.rootStore.mainLoaderStore.resume();
                    this.queryUtility.fetch();
                } catch (err) {
                    this.rootStore.mainLoaderStore.resume();
                    this.rootStore.notificationStore.error(
                        "An unexpected error occurred. Unable to delete device.",
                        err
                    );
                }
            },
            yesLabel: "Delete",
            noLabel: "Cancel",
            description: "You won't be able to revert this action.",
        });
    }
}

export default DeviceListViewStore;
